module.exports = __webpack_public_path__ + "img/AGM Reports.1a1e2d1e.svg";